import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { generateUuid } from '@ftr/contracts/type/shared'

@Component({
  standalone: true,
  imports: [FormsModule],
  selector: 'ftr-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.css'],
})
export class SwitchComponent {
  @Input() id = `switch-${generateUuid()}`
  @Input() value = false
  @Output() onValueChange = new EventEmitter<boolean>()
}
